import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "MAP", to: "/app" },
  { label: "PLANS", to: "/app?panel=plans" },
  { label: "TRACKING", to: "/app?panel=tracking" },
  { label: "MOUNTS", to: "/mounts" },
  { label: "ABOUT", to: "/about" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname.startsWith("/app")) return null;

  return (
    <header className="sticky top-0 z-50 border-b border-edge bg-void/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <Link key={n.label} to={n.to} data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-400 transition-colors hover:text-yellow">
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          {user ? (
            <button onClick={() => navigate("/app")} data-testid="nav-open-app"
              className="bg-yellow px-5 py-2.5 font-head text-sm font-bold uppercase tracking-wider text-black transition-colors hover:bg-yellow-hover">
              Open Map
            </button>
          ) : (
            <>
              <Link to="/signin" data-testid="nav-signin"
                className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-300 hover:text-yellow">
                Sign In
              </Link>
              <Link to="/signin" data-testid="nav-start-free"
                className="flex items-center gap-1 bg-yellow px-5 py-2.5 font-head text-sm font-bold uppercase tracking-wider text-black transition-colors hover:bg-yellow-hover">
                Start Free <ArrowUpRight className="h-4 w-4" />
              </Link>
            </>
          )}
        </div>
        <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle"
          className="text-gray-200 lg:hidden">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-edge bg-panel px-5 py-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {NAV.map((n) => (
              <Link key={n.label} to={n.to} onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${n.label.toLowerCase()}`}
                className="border-b border-edgesubtle py-3 font-head text-lg font-bold uppercase tracking-wide text-gray-200">
                {n.label}
              </Link>
            ))}
            <div className="mt-4 flex flex-col gap-3">
              {user ? (
                <button onClick={() => { setOpen(false); navigate("/app"); }}
                  className="bg-yellow py-3 font-head font-bold uppercase text-black">Open Map</button>
              ) : (
                <>
                  <Link to="/signin" onClick={() => setOpen(false)}
                    className="border border-edge py-3 text-center font-head font-bold uppercase text-gray-200">Sign In</Link>
                  <Link to="/signin" onClick={() => setOpen(false)}
                    className="bg-yellow py-3 text-center font-head font-bold uppercase text-black">Start Free</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
